export const GET_ORDER = '/yfsbe/api/warehouse/getOrderDetailsForTracking';
export const GET_SAAS_ACCOUNT_BY_DOMAIN = "/api/saas-accounts/by-domain"